import { isEmpty } from 'lodash4';

// This exists to solve platform specific display issues
// the scroll portion is for long questions and results on mobile
// the environment prop is for resources

export class PollPlatformServant {
  public _scrollDelegate: any;
  public _method: string;
  public _environment: string;

  constructor() {
    this._scrollDelegate = () => false;
    this._method = '';
    this._environment = '';
  }

  set scrollDelegate(delegate: () => void) {
    this._scrollDelegate = delegate;
  }

  set scrollMethod(method: string) {
    this._method = method;
  }

  set environment(type: string) {
    this._environment = type;
  }

  get environment() {
    return this._environment;
  }

  scroll(): void {
    if (!isEmpty(this._scrollDelegate) || !isEmpty(this._method)) {
      this._scrollDelegate[this._method]();
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/servants/poll_platform_servant.ts